export const TopHeadErrorIcon = ({ className }) => {
  return (
    <svg
      width="338"
      height="389"
      viewBox="0 0 338 389"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M279.618 174.476C279.618 245.358 232.194 312.457 189.959 331.408M189.959 331.408C185.137 347.118 173.215 353.111 169.426 353.111C164.635 353.111 146.84 343.53 146.84 316.837M189.959 331.408C191.233 327.253 192.012 322.419 192.012 316.837M59.1904 174.476C59.1904 245.358 106.615 312.457 148.85 331.408M58.5498 147.784C58.5498 147.784 52.3464 140.237 49.6075 149.148C44.5234 165.69 59.2342 174.477 59.2342 174.477M279.831 147.784C279.831 147.784 286.035 140.237 288.774 149.148C293.858 165.69 279.147 174.477 279.147 174.477M280.26 158.035C280.26 242.229 225.506 320.943 169.383 320.943C113.26 320.943 58.506 242.229 58.506 158.035C58.506 43.7454 136.531 33.4844 169.383 33.4844C202.236 33.4844 280.26 43.7454 280.26 158.035Z"
        stroke="currentColor"
        strokeWidth="2.7377"
      />
      <path
        d="M169.23 199.051C167.595 199.051 166.317 198.539 165.397 197.517C164.58 196.495 164.069 195.064 163.864 193.225L160.185 129.14C159.98 126.074 160.645 123.621 162.178 121.782C163.711 119.942 166.062 119.022 169.23 119.022C172.194 119.022 174.443 119.942 175.976 121.782C177.509 123.621 178.122 126.074 177.815 129.14L174.136 193.225C174.034 195.064 173.523 196.495 172.603 197.517C171.785 198.539 170.661 199.051 169.23 199.051ZM169.23 228.793C166.266 228.793 163.864 227.873 162.024 226.033C160.185 224.194 159.265 221.843 159.265 218.981C159.265 216.119 160.185 213.82 162.024 212.082C163.864 210.242 166.266 209.322 169.23 209.322C172.194 209.322 174.545 210.242 176.282 212.082C178.02 213.82 178.889 216.119 178.889 218.981C178.889 221.843 178.02 224.194 176.282 226.033C174.545 227.873 172.194 228.793 169.23 228.793Z"
        fill="currentColor"
      />
      <path
        d="M336 47.8566V10.2131C336 5.67714 332.323 2 327.787 2H290.143M336 340.791V378.434C336 382.97 332.323 386.648 327.787 386.648H290.143M2 47.8566V10.2131C2 5.67714 5.67714 2 10.2131 2H47.8566M2 340.791V378.434C2 382.97 5.67714 386.648 10.2131 386.648H47.8566"
        stroke="currentColor"
        strokeWidth="2.7377"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
